import React from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';
import { TextField } from '@change/ds-forms/next';

import { useSunriseHoldoutExperiment } from '../../../../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';

type Props = {
	currencySymbol: string;
	errorMessage: string | null;
	isSelected: boolean;
	onChange: (value: string) => void;
	onFocus: () => void;
	value: number;
	placeholder?: string;
};

export function AmountInput({
	currencySymbol,
	errorMessage,
	isSelected,
	onChange,
	onFocus,
	value,
	placeholder,
}: Props): JSX.Element {
	const currencyRef = React.useRef<HTMLSpanElement>(null);

	const sunriseHoldoutExperiment = useSunriseHoldoutExperiment({
		isSelected,
		currencyRef,
		currencySymbol,
		amountInputValue: value,
	});

	return (
		<ThemeProvider>
			<TextField
				inputMode="numeric"
				isReadOnly={false}
				label="amount"
				labelIsVisible={false}
				name="amount"
				onChange={onChange}
				onFocus={onFocus}
				placeholder={placeholder}
				type="text"
				value={value ? String(value) : ''}
				inputOptions={{
					// we use pl-11 to ensure there is space for longer currency, ex "USD". This is handled differently in the sunrise holdout experiment
					className: `pl-11 text-sm ${sunriseHoldoutExperiment.amountInputClasses}`,
					style: sunriseHoldoutExperiment.amountInputStyle,
					// TODO: Remove this @ts-expect-error when TextField props are typed to allow these attributes
					//       https://change.atlassian.net/browse/CHANGE-77254
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-expect-error
					'data-qa': 'custom-amount-input',
					'data-testid': 'payment-form-amount-input',
					leadingIcon: (
						<ThemeProvider>
							<span
								ref={currencyRef}
								className="pointer-events-none absolute left-3 top-1/2 inline-flex -translate-y-1/2 items-center justify-center text-sm"
								sx={{
									color: sunriseHoldoutExperiment.amountInputStyle.color || undefined,
								}}
							>
								{currencySymbol}
							</span>
						</ThemeProvider>
					),
					pattern: '[0-9]*',
				}}
				isInvalid={!!errorMessage}
			/>
		</ThemeProvider>
	);
}
